import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo5/documentos.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo5 } from "../../../routes/Module5";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo5/Actividad 1.mp3";

const Actividad1 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "MÓNICA" },
    ans2: { value: "", valid: "", correctValue: "JOSÉ" },
    ans3: { value: "", valid: "", correctValue: "ESTELA" },
    ans4: { value: "", valid: "", correctValue: "ELI" },
  });
  const infoUnidad = modulo5.content[0];
  const infoAct = modulo5.content[0].activities[0];
  const crumbs = [
    {
      title: modulo5.title,
      url: "/" + modulo5.url,
    },
    {
      title:
        modulo5.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo5.content[0].activities[1].name}`,
    linkNext: `${modulo5.url}/${modulo5.content[0].path}/${modulo5.content[0].activities[1].path}`,
    titlePrev: modulo5.title,
    linkPrev: modulo5.url,
  };
  const metadata = {
    color: modulo5.color,
    title: `${modulo5.title} - ${infoAct.name}`,
    name: modulo5.title,
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"].toUpperCase() ===
          answers[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };
  const handleAnswers = (event, name) => {
    event.preventDefault();
    setAnswers({
      ...answers,
      [name]: { ...answers[name], value: event.target.value },
    });
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <div className="row">
        <div className="col-lg-10 col-12">
          <p>
            <small className={`c-${modulo5.color} hat-text`}>
              <FontAwesomeIcon icon={faEye} /> Observamos
            </small>
          </p>
          <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

          <ul>
            <li>Observa a las personas y sus documentos.</li>
          </ul>
          <img src={Imagen1} className="img-fluid mb-5" alt="Grupo" />
          <ul>
            <li>
              Coloca el nombre de cada persona junto al documento que
              corresponda.
            </li>
          </ul>
          <div className="row align-items-center ms-lg-4 ms-0">
            <div className="col-lg-5 col-md-6 col-12">
              <Card>
                <div className="text-center">DNI</div>
              </Card>
            </div>
            <div className="col-lg-4 col-md-6 offset-lg-1 offset-0 col-12">
              <input
                type="text"
                className={"form-control " + answers.ans1.valid}
                value={answers.ans1.value}
                onChange={(event) => handleAnswers(event, "ans1")}
              />
            </div>
          </div>

          <div className="row align-items-center ms-4">
          <div className="col-lg-5 col-md-6 col-12">
              <Card>
                <div className="text-center">Pasaporte</div>
              </Card>
            </div>
            <div className="col-lg-4 col-md-6 offset-lg-1 offset-0 col-12">
              <input
                type="text"
                className={"form-control " + answers.ans2.valid}
                value={answers.ans2.value}
                onChange={(event) => handleAnswers(event, "ans2")}
              />
            </div>
          </div>
          <div className="row align-items-center ms-4">
          <div className="col-lg-5 col-md-6 col-12">
              <Card>
                <div className="text-center">Licencia de conducir</div>
              </Card>
            </div>
            <div className="col-lg-4 col-md-6 offset-lg-1 offset-0 col-12">
              <input
                type="text"
                className={"form-control " + answers.ans3.valid}
                value={answers.ans3.value}
                onChange={(event) => handleAnswers(event, "ans3")}
              />
            </div>
          </div>
          <div className="row align-items-center ms-4">
          <div className="col-lg-5 col-md-6 col-12">
              <Card>
                <div className="text-center">DNI para menores</div>
              </Card>
            </div>
            <div className="col-lg-4 col-md-6 offset-lg-1 offset-0 col-12">
              <input
                type="text"
                className={"form-control " + answers.ans4.valid}
                value={answers.ans4.value}
                onChange={(event) => handleAnswers(event, "ans4")}
              />
            </div>
          </div>
          <div className="row ">
            <div className="col-lg-5 col-md-12 offset-lg-5 offset-0 col-12 text-end">
              <button
                className={`btn btn-${modulo5.color}`}
                onClick={validateAnswers}
              >
                Enviar respuestas
              </button>
            </div>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen las imágenes: ayude a identificar los
          documentos y a relacionar a cada persona con su documento. Destaque
          que Jailer no tiene ninguno.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad1;
